module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-not-exist"
  }, [_c('IconSwitch', {
    attrs: {
      "type": 'qrcode'
    }
  }), _vm._v(" "), _c('Icon'), _vm._v(" "), _c('Inputs', {
    attrs: {
      "type": 'accountnotexist'
    },
    on: {
      "inputText": _vm.getAccount,
      "enterInput": _vm.enterInput
    }
  }), _vm._v(" "), _c('Warn', {
    attrs: {
      "type": 'accountnotexist'
    }
  }), _vm._v(" "), _c('Buttons', {
    ref: "btn",
    attrs: {
      "type": 'signin',
      "data": _vm.account
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35dca8df"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/new-login-2018/login/Accountnotexist.vue
// module id = 718
// module chunks = 1